import clsx from "clsx";
import translate from "../../locales";

export function Question({ question = "", description = "", children }) {
  const descriptionText = translate(description, {}, "");
  return (
    <fieldset className={clsx("question")}>
      <div className="question__header">
        <p className={clsx("question__label")}>{translate(question)}</p>
        {descriptionText && (
          <p className={clsx("question__description")}>{descriptionText}</p>
        )}
      </div>
      {children}
    </fieldset>
  );
}
